import React from 'react';

// See https://hello.atlassian.net/wiki/spaces/EDAI/pages/4834594169/LDR+Keeping+Emotion+Global+usages
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, Global, keyframes } from '@emotion/react';

// these colours do not exist in ads yet but are from figma see: https://hello.atlassian.net/wiki/spaces/DST/pages/6378806627/AI+Components+Patterns+Inventory
const backgroundRainbow = `linear-gradient(to right,
	color-mix(in srgb, #1F69DA 70%, currentColor) 7%,
	color-mix(in srgb, #C16CD4 70%, currentColor) 29%,
	color-mix(in srgb, #F5A117 70%, currentColor) 65%,
	color-mix(in srgb, #79AE44 70%, currentColor) 85%)`;

const acceptBackgroundShimmerSweep = keyframes({
	from: {
		backgroundPosition:
			'calc(40% - 40vw + var(--ai-accept-shimmer-right-edge, 100vw)) 0, var(--ai-accept-shimmer-left-edge, 0px) 0',
	},
	to: {
		backgroundPosition:
			'calc(60% - 60vw + var(--ai-accept-shimmer-left-edge, 0px)) 0, var(--ai-accept-shimmer-left-edge, 0px) 0',
	},
});

const acceptShimmerStyles = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'.ProseMirror .ai-suggestions-accept-shimmer-background': {
		// Edge cases: Apply the shimmer background directly to the lozenge text and text highlight mark
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
		'&:not(.statusView-content-wrap), & .lozenge-text, & .fabric-text-color-mark': {
			'--ai-accept-shimmer-width':
				'calc(var(--ai-accept-shimmer-right-edge, 100vw) - var(--ai-accept-shimmer-left-edge, 0px))',
			backgroundColor: 'currentColor',
			backgroundImage: `linear-gradient(90deg, currentColor 40%, transparent 45%, transparent 55%, currentColor 60%), var(--ai-accept-shimmer-rainbow, ${backgroundRainbow})`,
			backgroundAttachment: 'fixed, fixed',
			backgroundSize:
				'calc(var(--ai-accept-shimmer-width) + var(--ai-accept-shimmer-width) + var(--ai-accept-shimmer-width)) 100vh, var(--ai-accept-shimmer-width) 100vh',
			backgroundRepeat: 'no-repeat, no-repeat',
			backgroundClip: 'text',
			WebkitTextFillColor: 'transparent',
			animation: `${acceptBackgroundShimmerSweep} var(--ai-accept-shimmer-duration, 1300ms) cubic-bezier(.4, 0, .5, 1) both`,
			'@media (prefers-reduced-motion: reduce), (forced-colors: active)': {
				animation: 'none',
				backgroundImage: 'none',
				WebkitTextFillColor: 'currentColor',
			},
		},
	},
	// Do not clear the colour of emojis so they don't appear as black squares
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'.ProseMirror .ai-suggestions-accept-shimmer-background[data-emoji-id]': {
		WebkitTextFillColor: 'currentColor',
	},
	// Do not clear the text highlight colour during the shimmer
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'.ProseMirror .ai-suggestions-accept-shimmer-background.text-highlight': {
		WebkitTextFillColor: 'currentColor',
	},
});

export const AcceptShimmerGlobalStyles = (): JSX.Element => <Global styles={acceptShimmerStyles} />;
